/* @flow */

import * as React from 'react';

import styles from './LocalSearchLinks.scss';
import TrackedLink from 'common/components/TrackedLink';

type Domain = 'fi' | 'se' | 'com';

function localSearchURL(domain: Domain) {
  return `https://venuu.${domain}/${__LOCALE__}/${__('routes.venues')}`;
}

function getTrackingProps(domain: Domain) {
  return {
    'Link Name': 'Local Search Link',
    'Target Site': `venuu_${domain}`
  };
}

export default function LocalSearchLinks() {
  return (
    <section className={styles.container}>
      <h5 className={styles.heading}>
        {__('search.local_search_links.title')}
      </h5>
      <div>
        <TrackedLink
          className={styles['link--fi']}
          href={localSearchURL('fi')}
          trackingProperties={getTrackingProps('fi')}
        >
          {__('search.local_search_links.fi')}
          {' »'}
        </TrackedLink>
        <TrackedLink
          className={styles['link--se']}
          href={localSearchURL('se')}
          trackingProperties={getTrackingProps('se')}
        >
          {__('search.local_search_links.se')}
          {' »'}
        </TrackedLink>
      </div>
    </section>
  );
}
